var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83331 4.83342H2.99998C2.55795 4.83342 2.13403 5.00902 1.82147 5.32158C1.50891 5.63414 1.33331 6.05806 1.33331 6.50009V14.0001C1.33331 14.4421 1.50891 14.866 1.82147 15.1786C2.13403 15.4912 2.55795 15.6668 2.99998 15.6668H10.5C10.942 15.6668 11.3659 15.4912 11.6785 15.1786C11.9911 14.866 12.1666 14.4421 12.1666 14.0001V13.1668M11.3333 3.16676L13.8333 5.66676M14.9875 4.48759C15.3157 4.15938 15.5001 3.71424 15.5001 3.25009C15.5001 2.78594 15.3157 2.34079 14.9875 2.01259C14.6593 1.68438 14.2141 1.5 13.75 1.5C13.2858 1.5 12.8407 1.68438 12.5125 2.01259L5.49998 9.00009V11.5001H7.99998L14.9875 4.48759Z",
    stroke: "#8D8D8D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.8f7783b8f988a3a3a4e31d38d44061bb.svg";
export { ForwardRef as ReactComponent };